import { useEffect, useState } from 'react';
import { getPackageDetails, getCanonicalPackageName, getFlattenedServices, packageDetails } from '../lib/packageDetails';

export function expandCommercialTiers(line) {
  const expanded = [];
  for (const tier of line?.tiers || []) {
    const services = [];
    for (const item of tier.included || []) {
      const match = /^Everything in (.+)$/i.exec(item.trim());
      services.push(...(match ? expanded.find(t => t.name.toLowerCase() === match[1].toLowerCase())?.services || [] : [item]));
    }
    expanded.push({ key: tier.key, name: tier.name, shift: tier.frequency, designedFor: line.tagline, services: [...new Set(services)] });
  }
  return expanded;
}

export function usePropertyPackages(property) {
  const type = String(property?.property_type || 'residential').toLowerCase();
  const commercial = !['residential', 'multifamily', 'multi_family', 'apartment', 'apartments'].includes(type);
  const [state, setState] = useState({ type: null, line: null, error: '' });
  useEffect(() => {
    if (!commercial) return;
    const controller = new AbortController();
    setState({ type, line: null, error: '' });
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/commercial/service-lines?visibility=commercial`, { signal: controller.signal })
      .then(r => { if (!r.ok) throw new Error('Package catalog unavailable'); return r.json(); })
      .then(d => { if (controller.signal.aborted) return; const line = d.service_lines?.find(l => l.property_type === type); if (!line) throw new Error('No approved packages for this property type'); setState({ type, line, error: '' }); })
      .catch(e => { if (e.name !== 'AbortError') setState({ type, line: null, error: e.message }); });
    return () => controller.abort();
  }, [type, commercial]);
  if (!commercial) {
    const name = getCanonicalPackageName(property?.package_type);
    return { commercial, loading: false, error: '', current: { name, ...getPackageDetails(property?.package_type), services: getFlattenedServices(property?.package_type) }, tiers: Object.keys(packageDetails).map(name => ({ name, ...packageDetails[name], services: getFlattenedServices(name) })) };
  }
  const line = state.type === type ? state.line : null;
  const tiers = expandCommercialTiers(line);
  const selected = String(property?.tier || property?.tier_label || property?.service_tier || property?.package_type || '').toLowerCase();
  const current = tiers.find(t => [t.key, t.name.toLowerCase()].includes(selected));
  return { commercial, line, tiers, current: current || { name: property?.tier_label || (property?.tier ? 'Assigned package unavailable' : 'Package awaiting confirmation'), shift: property?.service_frequency || 'As agreed in the service agreement', services: (property?.contracted_services || []).filter(s => typeof s === 'string') }, loading: !line && !state.error, error: state.error };
}